import { css, StyleDeclarationValue, StyleSheet } from 'aphrodite';
import { Avatar as RadixAvatar } from 'radix-ui';
import { ReactNode } from 'react';
import { THEME } from '../Theme/theme';

const styleSheet = StyleSheet.create({
	fallback: {
		alignItems: 'center',
		backgroundColor: THEME.colors.chart.shuffleGray,
		display: 'flex',
		fontSize: THEME.typography.fontSizes.md,
		height: '100%',
		justifyContent: 'center',
		lineHeight: 1,
		textTransform: 'uppercase',
		width: '100%',
	},
	image: {
		borderRadius: 'inherit',
		height: '100%',
		objectFit: 'cover',
		width: '100%',
	},
	root: {
		alignItems: 'center',
		backgroundColor: THEME.colors.chart.shuffleGray,
		border: `1px solid ${THEME.colors.chart.aceGray}`,
		borderRadius: '50%',
		display: 'inline-flex',
		height: 60,
		justifyContent: 'center',
		overflow: 'hidden',
		position: 'relative',
		userSelect: 'none',
		verticalAlign: 'middle',
		width: 60,
	},
	smallText: {
		fontSize: THEME.typography.fontSizes.xxs,
	},
});

export interface AvatarProps {
	altText?: string;
	className?: string;
	fallback?: ReactNode;
	fallbackStyles?: StyleDeclarationValue[];
	fallbackText?: string;
	imgSrc?: string;
	smallText?: boolean;
	styles?: StyleDeclarationValue[];
}

export function Avatar({
	altText,
	className,
	fallback,
	fallbackStyles = [],
	fallbackText,
	imgSrc,
	smallText = false,
	styles = [],
}: AvatarProps) {
	const fallbackContent = fallback ?? fallbackText;
	return (
		<RadixAvatar.Root className={`${css(styleSheet.root, ...styles)}${className ? ` ${className}` : ''}`}>
			{imgSrc ? <RadixAvatar.Image className={css(styleSheet.image)} src={imgSrc} alt={altText} /> : null}
			{fallbackContent ? (
				<RadixAvatar.Fallback
					className={css(styleSheet.fallback, smallText && styleSheet.smallText, ...fallbackStyles)}
				>
					{fallbackContent}
				</RadixAvatar.Fallback>
			) : null}
		</RadixAvatar.Root>
	);
}
